import "./Header.css"
import logo from '../elia-logo-narrow.png';
import motlogo from '../mot-logo.png';
import tsatal from '../tsatal.png';
import { Row, Col, Container } from 'react-bootstrap';
const Header = () => {

    return (
        <>

            <Row >
                
                <Col sm={12} className={"p-1 "}>
                    <div id="logos">
                        <img src={logo} alt="Logo" id={"elia-logo"} />
                        <img src={motlogo} alt="MotLogo" id={"mot-logo"} />
                        <img src={tsatal} alt="TsatalLogo" id={"tsatal-logo"} />
                    </div>


                </Col>
                <Col md={1}></Col>
            
                <Col md={10} sm={12 } className={"p-1 "}>

                    <h3> מידע כללי על התחבורה הציבורית בירושלים</h3>
                    <div id="text-paragraph">


                        <ul>
                            <li><h5>כיצד ניתן לשלם על נסיעה בשירות התחבורה הציבורית בירושלים?</h5>
                                <p className={'paragraph-text'}>
                                ברב קו טעון מראש בחוזה מתאים או באפליקציות כגון מוביט, פנגו, רב פס וסלו. לא ניתן לרכוש כרטיסים במזומן על גבי האוטובוס או בתוך קרונות הרכבת הקלה. לתשומת ליבכם, התשלום ברכבת הקלה באמצעות האפליקציה הינו מבוסס מיקום, לא נדרשת בחירת תחנת עליה או סריקת QR. תשלום עבור נסיעה בירושלים כוללת גם מעבר חופשי עד 90 דקות.                                </p>
                            </li>
                            <li><h5>כיצד ניתן לקבל מידע על תחבורה ציבורית סדירה?
                            </h5>
                                <p className={'paragraph-text'}>
                                מרכז השירות הארצי לתחבורה ציבורית בטלפון 8787*, באתר האינטרנט bus.gov.il וביישומוני המידע כגון מוביט ואיפה בוס.

לקבלת זמני נסיעה בזמן אמת כנסו ליישומוני המידע.

                                  
                                </p>
                                <p id="comment">
                                *המידע מעודכן לתאריך 29.10.23.
קווים לא פעילים נכון ל-25.10.23 שלא מופיעים בטבלה: 2. קו 97 פועל עד השעה 20:00 בלבד.
מוצגות חלופות נסיעה עיקריות בלבד מהמלון אל היעד, ייתכנו שינויים בכיוון הנגדי.
                                </p>
                                
                                </li>
                        </ul>
                    </div>

                </Col>
                <Col md={1}></Col>
            </Row>

        </>
    )
}
export default Header
